'use client';

import { AtomicSearchInterfaceWrapper } from '@components/Search/AtomicSearchInterfaceWrapper';
import {
  AtomicListingContext,
  AtomicListingProvider,
} from '@contexts/coveo/AtomicListingContext';
import {
  AtomicLayoutSection,
  AtomicNoResults,
  AtomicQueryError,
  AtomicSearchLayout,
  SortBy,
  SortCriterion,
} from '@coveo/atomic-react';

import { PublisherAssets } from '@components/Blocks/PublisherAssets/PublisherAssets';
import { AtomicPaginationSection } from '@components/PublisherProfile/AtomicPaginationSection';
import { AtomicQueryRefinement } from '@components/PublisherProfile/AtomicQueryRefinement';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { usePathname } from 'next/navigation';

type PublisherAssetsListingProps = {
  gridCols?: number;
  queryExpression?: string;
  searchQuery?: string;
  numberOfResults?: number;
  uniqueId?: string;
  sortCriteria?: SortCriterion | SortCriterion[];
  paginationMicrocopy: MicrocopyFragment[];
};

export const PublisherAssetsListing = ({
  gridCols = 5,
  searchQuery,
  numberOfResults = 24,
  uniqueId = 'PublisherAssets',
  sortCriteria = { by: SortBy.Relevancy },
  paginationMicrocopy,
}: PublisherAssetsListingProps) => {
  const pathname = usePathname();
  const publisherId = pathname?.split('/').filter(Boolean).pop();

  return (
    <div className="mb-10 md:mb-0">
      <AtomicListingProvider
        uniqueId={uniqueId}
        sortCriteria={{ name: undefined, criterion: sortCriteria }}
        queryExpression={`@publisher_id == "${publisherId}"`}
        searchQuery={searchQuery}
        numberOfResults={numberOfResults}
      >
        <AtomicSearchInterfaceWrapper
          shouldExecuteFirstSearch
          reflectStateInUrl={false}
          context={AtomicListingContext}
          id={uniqueId}
        >
          <AtomicSearchLayout style={{ display: 'block' }}>
            <AtomicLayoutSection section="main">
              <div className="mb-6">
                <AtomicQueryRefinement context={AtomicListingContext} />
              </div>
            </AtomicLayoutSection>
          </AtomicSearchLayout>
          <AtomicQueryError />
          <AtomicNoResults />
          <PublisherAssets gridCols={gridCols} />
          <div className="flex justify-center md:mb-6 md:mt-6">
            <AtomicPaginationSection
              paginationMicrocopySet={paginationMicrocopy}
              context={AtomicListingContext}
            />
          </div>
        </AtomicSearchInterfaceWrapper>
      </AtomicListingProvider>
    </div>
  );
};
